// extracted by mini-css-extract-plugin
export default {"top":"style_top__99u4P","profile":"style_profile__ts5+b","image":"style_image__VHyBH","name":"style_name__iyxOi","Shouts":"style_Shouts__Suzhs","options":"style_options__tk7ET"};